import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app'

// Registro público por slug: no requiere sesión
export const publicTournamentsAPI = {
  getInfo (slug) {
    return axios.get(`${API_BASE_URL}/public-tournaments/${encodeURIComponent(slug)}/`)
  },

  register (slug, data) {
    return axios.post(
      `${API_BASE_URL}/public-tournaments/${encodeURIComponent(slug)}/register/`,
      data
    )
  }
}
